import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsReporting(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_REPORTING,
    ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORTS_REPORTING, options)
}

function _getReportReporting(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_REPORTING, ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING, options)

}
function _getReportReportingPreview(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_REPORTING, ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING_PREVIEW, options)
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORTS_REPORTING]: _getReportsReporting,
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING]: _getReportReporting,
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING_PREVIEW]: _getReportReportingPreview,
}